var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTervinningBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "atervinning",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 163.48 70.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "border",
    d: "M23.46.25h109.2V16.73h16.8l4.7,1.8,9,12.75-3.64,7.32L160,55.89,23.72,63.19s3.48,5,.83,6.5-11.37,1.1-14-.75-1.88-9.52-2.89-10S3,57,2.67,56s-.58-22.59-1.53-24.2S-.22,27.34,1,22.56s3.44-3.34,5.9-8.37c1.48-3-.83-8,4.56-10.1S23.46.25,23.46.25Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTervinningBorder);
export default __webpack_public_path__ + "static/media/återvinning-border.b743d93b.svg";
export { ForwardRef as ReactComponent };